import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { getEnv } from 'utils';
import { persistedRootReducer } from './rootReducer';
const middlewares = [];

if (getEnv('REACT_APP_ENVIRONMENT') === 'development') {
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}

export const store = configureStore({
  reducer: persistedRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(...middlewares),
  devTools: false,
});

export const persistor = persistStore(store);
